import { useEffect, useState } from "react";

const DURATION_SECONDS = 17 * 60 + 34;
const startedAt = Date.now();

function remainingSeconds(): number {
  const elapsed = Math.floor((Date.now() - startedAt) / 1000);
  return DURATION_SECONDS - (elapsed % DURATION_SECONDS);
}

export function useLoopingCountdown() {
  const [seconds, setSeconds] = useState(remainingSeconds);

  useEffect(() => {
    const id = window.setInterval(() => setSeconds(remainingSeconds()), 1000);
    return () => window.clearInterval(id);
  }, []);

  const safe = seconds === DURATION_SECONDS ? DURATION_SECONDS : seconds;
  return {
    hours: Math.floor(safe / 3600),
    minutes: Math.floor((safe % 3600) / 60),
    secs: safe % 60,
  };
}
